import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionHowManyPlantsPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-where-keep-plants')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionHowManyPlants.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionHowManyPlants.noneYet'),
          value: 'none_yet',
        },
        {
          text: t('pages.onboarding.questionHowManyPlants.oneToThree'),
          value: '1_3',
        },
        {
          text: t('pages.onboarding.questionHowManyPlants.fourToTen'),
          value: '4_10',
        },
        {
          text: t('pages.onboarding.questionHowManyPlants.elevenToTwenty'),
          value: '11_20',
        },
        {
          text: t('pages.onboarding.questionHowManyPlants.twentyPlus'),
          value: '20_plus',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
